import React from 'react';
import { connect } from 'react-redux';
import { findMatch } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import CohortAxisDropdown from '../components/CohortAxisDropdown';
import CohortBinsDropdown from '../components/CohortBinsDropdown';
import { cohortAxis, cohortChart } from '../constants';
import { filterableFields, getCohortActiveDictionary } from '../../helper';
import {
  changeCohortVisualisationYAxis,
  changeCohortVisualisationBins,
} from '../actions';
import {
  chartReadStatus,
  filterValidChartQueries,
  filterYAxisFields,
} from '../helper';
import { findActiveQuery } from '../../state/shared';

const CohortHistagramVariables = ({
  cohort,
  category,
  changeYAxis,
  code,
  yAxis,
  bins,
  changeBinValue,
  fields,
}) => {
  const { readStatus } = chartReadStatus(filterValidChartQueries(cohort, cohortChart.HISTOGRAM));

  return (
    <>
      <CohortAxisDropdown
        axis={cohortAxis.Y_AXIS}
        value={yAxis}
        fields={filterYAxisFields(fields)}
        onChange={(name, label) => changeYAxis(category, code, cohortChart.HISTOGRAM, name, label)}
        disabled={readStatus === states.PENDING}
      />
      <CohortBinsDropdown
        value={bins}
        onChange={(name) => changeBinValue(category, code, cohortChart.HISTOGRAM, name)}
        disabled={readStatus === states.PENDING}
      />
    </>
  );
};

const mapStateToProps = ({
  cohorts: {
    cohorts,
  },
}, ownProps) => {
  const { cohort, query } = findActiveQuery(cohorts, ownProps);
  const chartQuery = findMatch(query.visualisations, ownProps.chartType);
  const dictionary = getCohortActiveDictionary(cohort) || { fields: [] };

  return ({
    cohort,
    queries: cohort.queries || [],
    fields: filterableFields(dictionary.fields),
    yAxis: chartQuery.yAxis.value,
    bins: chartQuery.bins.value,
  });
};

const mapDispatchToProps = {
  changeYAxis: changeCohortVisualisationYAxis,
  changeBinValue: changeCohortVisualisationBins,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortHistagramVariables);
